import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class CalendarService {
  moduleId: string;

  constructor(private http: HttpClient) {}

  find(moduleId: string, filters): Observable<any> {
    const params = new HttpParams()
      .set(filters.searchParams ? 'searchParams' : '', filters.searchParams)
      .set('creditFilter', filters.creditFilter)
      .set('archive', filters.archive)
      .set('pastClients', filters.pastClients)
      .set('showAll', filters.showAll)
      .set(filters.searchRange ? 'searchRange' : '', filters.searchRange)
      .set(filters.searchRangeColumn ? 'searchRangeColumn' : '', filters.searchRangeColumn);
    return this.http.get(`/data/${moduleId}`, { params });
  }
}

/** @deprecated Use CalendarService — kept for safe migration (AC-39). */
export { CalendarService as CalanderService };
